import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSmile } from "@fortawesome/free-solid-svg-icons";
import UserMood from "../UserMood/UserMood";

const styles = {
  userInfoContainer: {
    position: "absolute",
    bottom: "0",
    left: "0",
    height: "50px",
    background: "#434343",
    width: "100%",
    color: "white",
  },
  updateMood: {
    marginLeft: "10px",
  },
  userMood: {
    width: "15px",
    height: "15px",
  },
};

export default ({ profile, isOwner }) => {
  const classes = styles;

  return (
    <div style={classes.userInfoContainer}>
      <h4 className="userProfileName">
        <span className="userProfileFullName">{profile.full_name}</span>
        <span style={classes.updateMood}>
          <UserMood profile={profile} isOwner={isOwner}>
            <FontAwesomeIcon icon={faSmile} style={classes.userMood} />
          </UserMood>
        </span>
      </h4>
    </div>
  );
};
